import React from 'react';
import FormField from '../../../components/forms/FormField';

export default function IndicadoresDesenvolvimento() {
  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção coleta informações sobre indicadores de desenvolvimento do município.</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        name="idhm_indicador"
        label="IDHM"
        type="decimal3"
        placeholder="Digite o IDHM"
        helpText="Índice de Desenvolvimento Humano Municipal (0,000 a 1,000)"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser entre 0,000 e 1,000',
          },
          max: {
            value: 1,
            message: 'O valor deve ser entre 0,000 e 1,000',
          },
        }}
      />
      
      <FormField
        name="taxa_crescimento"
        label="Taxa de crescimento econômico anual (%)"
        type="percent"
        placeholder="Digite a taxa de crescimento"
        helpText="Taxa de crescimento econômico do último ano"
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="outros_indicadores"
        label="Outros indicadores relevantes"
        type="textarea"
        placeholder="Descreva outros indicadores relevantes"
        helpText="Informe outros indicadores de desenvolvimento relevantes para o município"
      />
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao7"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao7"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
